// extracted by mini-css-extract-plugin
export var aircallIframe = "_dn-3";
export var fabContainer = "_dn-5";
export var fabRinging = "_dn-6";
export var loadingOverlay = "_dn-4";
export var pulse = "_dn-7";
export var widgetContent = "_dn-2";
export var widgetPanel = "_dn-0";
export var widgetPanelExpanded = "_dn-1";